// extracted by mini-css-extract-plugin
module.exports = {"uiChartTooltip":"_1FzNUEDb","uiChartTooltipContent":"_1ITlAxNc","rightArrow":"kNX4JkVw","leftArrow":"_3EF7Utjv","uiChartTooltipHeading":"_8ypCs7hr","uiChartTooltipRow":"_2K_mbm3q"};